import React from "react"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Col } from "reactstrap"
import bg from "assets/images/background1.jpg";

const CarouselPage = () => {
  return (
    <React.Fragment>
      <Col xl={12}>
        <div className=" auth-full-bg pt-lg-5 p-4" style={{position:'relative', top:'0px', right:'0px', bottom:'0px',  left:'0px', margin:0, backgroundImage: "url(" + bg + ")", backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'relative',}}>
          <div className="w-100">
            <div className=""></div>
            <div className="d-flex h-100 flex-column">
              <div className="mb-3">
                <div className="row justify-content-center">
                  <div className="col-lg-7">
                    <div className="text-center">
                      <h4 className="mb-3">
                        <i className="bx bxs-quote-alt-left text-primary h1 align-top me-3"></i>
                        <span style={{color: 'white' }}>300 + Satisfied employees</span>
                      </h4>
                      <div dir="ltr">
                        <Carousel showThumbs={false} className="slider_css">
                          <div>
                            <div className="item">
                              <div className="py-3">
                                <p className="font-size-16 mb-4" style={{ color: 'white' }}>
                                   Want to be part of our mission: Empowering communities for health and sustainable livelihoods by providing quality healthcare, developing human resources for health and generating evidence to influence health policy. 
                                </p>
                                <p className="font-size-16 mb-4" style={{ color: 'white' }}>
                                   Apply and join us today !!
                                </p>

                                <div>
                                  <h4 className="font-size-16" style={{ color: 'white' }}>
                                    
                                  </h4>
                                  <p className="font-size-14 mb-0" style={{ color: 'white' }}>
                                     
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  )
}
export default CarouselPage
